import { createReducer, on } from '@ngrx/store';
import { checkToken, checkTokenSuccess, checkTokenFailure, optOut, optOutSuccess, optOutFailure } from './gdprNotice.actions';

export interface GdprNoticeState {
  checkToken: {
    data: any;
    message: string | null;
    error: any;
  }

  optOut: {
    data: any;
    message: string | null;
    error: any;
  }

  tokenValidated: boolean;
  // data: any;
  optOutDone: boolean;
  // message: string | null;
  // error: any;
}

const initialState: GdprNoticeState = {
  checkToken: {
    data: null,
    message: null,
    error: null,
  },
  optOut: {
    data: null,
    message: null,
    error: null,
  },

  tokenValidated: false,
  // data: null,
  optOutDone: false,
  // message: null,
  // error: null
};

export const gdprNoticeReducer = createReducer(
  initialState,
  on(checkToken, (state) => ({
    ...state,
    checkToken: { ...state.checkToken, message: null, error: null },
    tokenValidated: false,
  })),
  on(checkTokenSuccess, (state, { data }) => ({
    ...state,
    checkToken: { ...state.checkToken, data: data, message: "Token validation successful", error: null },
    tokenValidated: true,
  })),
  on(checkTokenFailure, (state, { error }) => ({
    ...state,
    checkToken: { ...state.checkToken, data: null, error: error },
    tokenValidated: false,
  })),
  on(optOut, (state) => ({
    ...state,
    optOut: { ...state.optOut, message: null, error: null },
    optOutDone: false,
  })),
  on(optOutSuccess, (state, { data }) => ({
    ...state,
    optOut: { ...state.optOut, data: data, message: "Opt-out successful", error: null },
    optOutDone: true,
  })),
  on(optOutFailure, (state, { error }) => ({
    ...state,
    optOut: { ...state.optOut, message: null, error: error },
    optOutDone: false,
  }))
);
